import { AssetCategory } from '@/shared/lib/sj-orm/models/asset.dto';
import {
  BankCellDto,
  BondsDto,
  BrokerageAccountDto,
  CentralizedWalletDto,
  CommercialRealEstateDto,
  CommodityAssetTokenDto,
  DebitAccountDto,
  DecentralizedWalletDto,
  ExchangeOptionsDto,
  ForwardsDto,
  FuturesDto,
  JewelryDto,
  LandDto,
  LegalEntityDto,
  MetalAccountDto,
  MyFundDto,
  OverTheCounterOptionsDto,
  PreciousGemstonesDto,
  PublicFundDto,
  ResidentialRealEstateDto,
  SecuritiesAndStocksDto,
} from '@/shared/lib/sj-orm/models/assets/categories';

type WithCategory = { category?: AssetCategory };

export const isBankCell = (asset: Record<string, unknown> & WithCategory): asset is BankCellDto =>
  asset.category === AssetCategory.BANK_CELLS;

export const isBond = (asset: Record<string, unknown> & WithCategory): asset is BondsDto =>
  asset.category === AssetCategory.BONDS;

export const isBrokerageAccount = (
  asset: Record<string, unknown> & WithCategory,
): asset is BrokerageAccountDto => asset.category === AssetCategory.BROKERAGE_ACCOUNT;

export const isCentralizedWallet = (
  asset: Record<string, unknown> & WithCategory,
): asset is CentralizedWalletDto => asset.category === AssetCategory.CENTRALIZED_WALLET;

export const isCommercialRealEstate = (
  asset: Record<string, unknown> & WithCategory,
): asset is CommercialRealEstateDto => asset.category === AssetCategory.COMMERCIAL_REAL_ESTATE;

export const isCommodityAssetToken = (
  asset: Record<string, unknown> & WithCategory,
): asset is CommodityAssetTokenDto => asset.category === AssetCategory.COMMODITY_ASSET_TOKENS;

export const isDebitAccount = (
  asset: Record<string, unknown> & WithCategory,
): asset is DebitAccountDto => asset.category === AssetCategory.DEBIT_ACCOUNTS;

export const isDecentralizedWallet = (
  asset: Record<string, unknown> & WithCategory,
): asset is DecentralizedWalletDto => asset.category === AssetCategory.DECENTRALIZED_WALLET;

export const isExchangeOptions = (
  asset: Record<string, unknown> & WithCategory,
): asset is ExchangeOptionsDto => asset.category === AssetCategory.EXCHANGE_OPTIONS;

export const isForwards = (asset: Record<string, unknown> & WithCategory): asset is ForwardsDto =>
  asset.category === AssetCategory.FORWARDS;

export const isFutures = (asset: Record<string, unknown> & WithCategory): asset is FuturesDto =>
  asset.category === AssetCategory.FUTURES;

export const isJewelry = (asset: Record<string, unknown> & WithCategory): asset is JewelryDto =>
  asset.category === AssetCategory.JEWELLERY;

export const isLand = (asset: Record<string, unknown> & WithCategory): asset is LandDto =>
  asset.category === AssetCategory.LAND;

export const isLegalEntity = (
  asset: Record<string, unknown> & WithCategory,
): asset is LegalEntityDto => asset.category === AssetCategory.LEGAL_ENTITIES;

export const isMetalAccount = (
  asset: Record<string, unknown> & WithCategory,
): asset is MetalAccountDto => asset.category === AssetCategory.METAL_ACCOUNTS;

export const isMyFund = (asset: Record<string, unknown> & WithCategory): asset is MyFundDto =>
  asset.category === AssetCategory.MY_FUND;

export const isOverTheCounterOptions = (
  asset: Record<string, unknown> & WithCategory,
): asset is OverTheCounterOptionsDto => asset.category === AssetCategory.OVER_THE_COUNTER_OPTIONS;

export const isPreciousGemstones = (
  asset: Record<string, unknown> & WithCategory,
): asset is PreciousGemstonesDto => asset.category === AssetCategory.PRECIOUS_STONES;

export const isPublicFund = (
  asset: Record<string, unknown> & WithCategory,
): asset is PublicFundDto => asset.category === AssetCategory.PUBLIC_FUND;

export const isResidentialRealEstate = (
  asset: Record<string, unknown> & WithCategory,
): asset is ResidentialRealEstateDto => asset.category === AssetCategory.RESIDENTIAL_REAL_ESTATE;

export const isSecuritiesAndStocks = (
  asset: Record<string, unknown> & WithCategory,
): asset is SecuritiesAndStocksDto => asset.category === AssetCategory.SECURITIES_AND_STOCKS;
